export const AnalyticsPreviewEnabled = 'AnalyticsPreviewEnabled';
export const CreateNewReturnEnabled = 'CreateNewReturnEnabled';
export const EditCalculationEnhancementsEnabled = 'EditCalculationEnhancementsEnabled';
export const EditableOptionsPanelEnabled = 'EditableOptionsPanelEnabled';
export const EnterpriseSelectorEnabled = 'EnterpriseSelectorEnabled';
export const ExportCommentsEnabled = 'ExportCommentsEnabled';
export const ExportPrintFormsEnabled = 'ExportPrintFormsEnabled';
export const FormsViewDrilldownEnabled = 'FormsViewDrilldownEnabled';
export const FullUserMenuEnabled = 'FullUserMenuEnabled';
export const HelpLinksIntegrationEnabled = 'HelpLinksIntegrationEnabled';
export const JournalEntryEnabled = 'JournalEntryEnabled';
export const ModernizationPreviewEnabled = 'ModernizationPreviewEnabled';
export const NotificationSettingsEnabled = 'NotificationSettingsEnabled';
export const PostHogEnabled = 'PostHogEnabled';
export const SearchableNavEnabled = 'SearchableNavEnabled';
export const NotificationsEnabled = 'NotificationsEnabled';
export const SubscribeToReportEnabled = 'SubscribeToReportEnabled';
export const DiagnosticReportViewEnabled = 'DiagnosticReportViewEnabled';
export const ExecutionSummaryEnabled = 'ExecutionSummaryEnabled';
export const AutoPostAmountsEnabled = 'AutoPostAmountsEnabled';
export const FilteredEnterAmountsEnabled = 'FilteredEnterAmountsEnabled';
export const DetailedWorkspacesEnabled = 'DetailedWorkspacesEnabled';
export const EditFormViewDescriptiveDataEnabled = 'EditFormViewDescriptiveDataEnabled';
export const EntityManagementAppEnabled = 'EntityManagementAppEnabled';
export const EntitySelectorInPrintModalEnabled = 'EntitySelectorInPrintModalEnabled';
export const Pillar2Enabled = 'Pillar2Enabled';
export const Pillar2DebugEnabled = 'Pillar2DebugEnabled';
export const Pillar2SubmissionEnabled = 'Pillar2SubmissionEnabled';
export const BulkEditReturnsEnabled = 'BulkEditReturnsEnabled';
export const CalcReviewEnhancedDescriptiveDataEnabled = 'CalcReviewEnhancedDescriptiveDataEnabled';
export const CalcReviewFormCommentsEnabled = 'CalcReviewFormCommentsEnabled';
